/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Content from './content';
// import Header from './header';
import Footer from './footer';
import {
  getAccessToken,
  getCurrentPathName,
  isEmpty,
  setAccessToken,
  setCurrentPage,
} from '../../core/lib/utils';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../core/store';
import useCognitoUtils from './../../core/lib/cognitoUtils';
import { onClearSession, onSetAccountSession } from '../../core/store/reducer/app/actions';
import {
  onThunkGetDocumentLinkCMS,
  onThunkGetGlobalDataCMS,
  onThunkGetlanguageCMS,
} from '../../core/store/thunk-new';
import { useTranslation } from 'react-i18next';
import Spinner from '../spinner/spinner';
import useCognito from './../../core/custom-hooks/useCognito';
import { onSetDataTranslate } from '../../core/lib/i18n';
import ConsentCookieForm from './consent-cookie-form';
import { useCookies } from 'react-cookie';

type Props = RouteComponentProps;

const Header = lazy(() => import('./header'));

const MainLayout: React.FC<Props> = ({ match }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation(['data']);
  const { getNewToken, signOutCognitoSession } = useCognitoUtils();
  const {
    app: { accountSession },
  } = useSelector((state: AppState) => state);

  const { CMSUrl, CMSToken } = useCognito();

  const [cookie, setCookie] = useCookies(['consentForm']);

  useEffect(() => {
    if (!accountSession.isLogin && getAccessToken()) {
      signOutCognitoSession();
    }
  }, [accountSession.isLogin]);

  useEffect(() => {
    if (!isEmpty(CMSUrl) && !isEmpty(CMSToken)) {
      dispatch(
        onThunkGetGlobalDataCMS({ wpml_language: i18n.language }, CMSUrl || '', CMSToken || ''),
      );

      dispatch(
        onThunkGetDocumentLinkCMS({ wpml_language: 'en' }, CMSUrl || '', CMSToken || '', [
          'Document',
        ]),
      );

      dispatch(
        onThunkGetlanguageCMS(
          { wpml_language: i18n.language },
          CMSUrl || '',
          CMSToken || '',
          (res: any) => {
            // code
            localStorage.setItem('translations', JSON.stringify(res.data));
            onSetDataTranslate(res.data);
          },
        ),
      );
    }
    console.log(localStorage.getItem('i18nextLng'));
  }, [i18n.language, CMSToken, CMSUrl]);

  useEffect(() => {
    const onRejected = () => {
      dispatch(onClearSession());
    };

    const refreshToken = () => {
      //check token
      if (accountSession.isLogin) {
        if (accountSession.expireTime - 300 < Date.now() / 1000) {
          try {
            getNewToken(
              accountSession.token,
              accountSession.idToken,
              accountSession.refreshToken,
            ).then((tokens) => {
              if (tokens) {
                const accountSessionTemp = { ...accountSession };
                accountSessionTemp.token = tokens.accessToken;
                accountSessionTemp.expireTime = Math.round(Date.now() / 1000 + 3600);
                accountSessionTemp.idToken = tokens.idToken;
                accountSessionTemp.refreshToken = tokens.refreshToken;
                dispatch(onSetAccountSession(accountSessionTemp));
                setAccessToken(tokens.accessToken);
                // if (getCurrentPathName() === routePaths.Medical) window.location.reload();
              }
            }, onRejected);
          } catch (error) {
            console.debug(error);
            dispatch(onClearSession());
          }
        }
      }
    };

    const refreshTokenInterval = setInterval(refreshToken, 10000);

    return () => {
      clearInterval(refreshTokenInterval);
    };
  }, [accountSession]);

  const checkHidden = window.location.href.includes('/public/assets');

  useEffect(() => {
    // if (checkHidden) {
    //   document.body.style.overflow = 'hidden';
    // } else {

    document.body.style.overflow = 'scroll';
    // }
  }, [checkHidden]);

  useEffect(() => {
    //set current page
    const currentPathName = window.location.pathname;
    if (
      !isEmpty(currentPathName) &&
      currentPathName !== '/logincallback' &&
      currentPathName !== '/logoutcallback'
    ) {
      setCurrentPage(currentPathName);
    }
  }, [match]);

  const renderFooter = (): React.ReactElement => {
    return <Footer pathName={getCurrentPathName()} />;
  };

  const onAgreeConsentForm = () => {
    const current = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(current.getFullYear() + 1);

    setCookie('consentForm', 'true', { expires: nextYear});
  };

  return (
    <div>
      {/* <TheSidebar /> */}
      <div className={''}>
        {!checkHidden && <Header pathName={getCurrentPathName()} />}
        <Spinner />
        <div className={''}>
          <Content />
        </div>
        {!checkHidden && renderFooter()}
        {cookie.consentForm !== true && (
          <ConsentCookieForm onAgreeConsentForm={onAgreeConsentForm} />
        )}
      </div>
    </div>
  );
};

export default MainLayout;
